// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"368":"52707c69","505":"ac8926b6","513":"ecff5bcf","703":"cb3c64ce","787":"21f0e217","791":"865bd875","829":"78934b95","844":"14860e2e"}[chunkId] + ".chunk.js";
};